import { Navigate, Routes, Route, Outlet } from 'react-router-dom'
import { QueryClient, QueryClientProvider, useQuery } from 'react-query'
import { PageTitle } from '../../_metronic/layout/core'
import DocumentSigningDashboard from './components/DocumentSigningDashboard'

const queryClient = new QueryClient()

const DocumentSigningDashboardPage = () => (
    <Routes>
        <Route
            element={
                <>
                    <Outlet />
                </>
            }
        >
            <Route
                path="/"
                element={
                    <>
                        <QueryClientProvider client={queryClient}>
                            <DocumentSigningDashboard />
                        </QueryClientProvider>
                    </>
                }
            />
        </Route>
        <Route path='*' element={<Navigate to='/error/404' />} />
    </Routes>
)

export default DocumentSigningDashboardPage
